<template>
  <button :class="btnClasses" @click.prevent="doClick">
    {{ btnTitle }}
  </button>
</template>

<script>
  import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'JobsApplyBtn',

    mixins: [AuthMixins],

    props: {
      payload: {
        type: [Object,String],
      },
      bubble_site_url: {
        type: String
      },
      closeCard: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        job: false,
        jobExpired: null,
        jobBeenApplied: null,
				jobId: null
      }
    },

    mounted() {
      this.job = typeof this.payload == 'string' ? JSON.parse(this.payload) : this.payload;
      this.jobId = this.job['section-overview']['job-id'];
			console.log("JIB",this.job);

			this.jobExpired = this.hasJobDateExpired(this.job['date-expire']);
      this.jobBeenApplied = this.hasJobBeenApplied();
    },

    methods: {
      doClick() {
        if (this.me) {

					if (this.job['section-hero']['hosting-app']) {
						window.open(`${this.bubble_site_url}/apply?job=${this.jobId}`, '_self');
						this.emitter.emit('gaEventTrack',  {'category':'job', 'action':'apply-open-tab', 'label':this.jobId});
					} else {
						this.emitter.emit("openModal", {
							name: 'ApplingForJob',
							job_id: this.jobId,
							org_id: this.job['section-overview']['section-org']['org-main-id'],
							redirect_url: this.job['section-hero']['apply-url'],
							expired: this.jobExpired,
							closeCard: this.closeCard
						});
						this.emitter.emit('gaEventTrack',  {'category':'job', 'action':'apply-open-modal', 'label':this.jobId});
					}
				} else {
					this.emitter.emit("openModal", { name: 'SignIn', persistent: false });
				}
        this.doTrack();
      },
      hasJobDateExpired(timestamp) {
        if (typeof timestamp !== 'undefined') {
          if(new Date(timestamp) < new Date()){
            return true;
          }
        }
        return false;
      },
      hasJobBeenApplied() {
        if (this.me) {
	        if (this.me.applications.length && this.jobId && this.jobId !== '') {
	          return this.me.applications.filter((application) => {
	            return application['job-id'] === this.jobId;
	          }).length;
	        }
          return false;
	      }
      },
      doTrack() {
      	let payload = {'job_id':this.jobId}
	  		return this.$api.trackJobApply(payload).then(
	        (response) => {
	        	if (response.data.status == 'success') {
              console.log('doTrack:trackJobApply', response.data.status);
	        	}
	        }
	      ).catch((response) => {
	        console.log("Could not track apply.", response);
	      });
      }
    },

    computed: {
      btnTitle() {
        return this.jobExpired ? 'Expired' : this.jobBeenApplied ? 'You\'ve Applied' : 'Apply';
      },
      btnClasses() {
        return {
          'btn': true,
          'btn-blue-light': !this.jobExpired && !this.jobBeenApplied,
          'btn-expired capitalize': this.jobExpired,
          'btn-applied capitalize': this.jobBeenApplied,
        }
      }
    }
  };
</script>
